<div [class]="'card ' + screenType()">
  <p-menubar [model]="items" styleClass="navbar">
    <ng-template #start>
      @if (screenType() === 'desktop') {
        <div class="max-w-14rem">
          <app-responsive-logo
            [path]="logoSrc()"
            ariaLabel="{{ 'NAVBAR.LOGO_LABEL' | translate }}"
          />
        </div>
      }
    </ng-template>
    <ng-template #end>
      <div
        class="flex items-center align-items-center justify-content-between gap-2"
      >
        @if (screenType() === 'mobile') {
          <div class="max-w-14rem">
            <app-responsive-logo
              [path]="logoSrc()"
              ariaLabel="{{ 'NAVBAR.LOGO_LABEL' | translate }}"
            />
          </div>
        }
        <div class="flex align-items-center justify-content-between gap-2">
          @if (isLoggedIn && currentRole === 'admin') {
            <p-button
              (onClick)="onHandleCopyOktaTokenButton()"
              [icon]="clipboardIcon"
              severity="primary"
              rounded
              tooltipPosition="bottom"
              pTooltip="{{ 'NAVBAR.COPY_OKTA_TOKEN_BUTTON' | translate }}"
            />
          }
          <app-dark-mode-switch />
          @if (isLoggedIn) {
            <app-menubar-popover />
          }
        </div>
      </div>
    </ng-template>
  </p-menubar>
</div>
